import { isMobileOnly } from 'mobile-device-detect';

const childrenRoutes = [
  {
    path: 'goal',
    name: 'streamer.widgets.goal',
    component: () => import('organisms/streamer/widgets/goal/GoalList'),
    meta: {
      help: 'https://help.capusta.space/widget',
      title: 'common.fundraising',
      type: 'DONATION_GOAL',
    },
  },
  {
    path: 'goal/form',
    name: 'streamer.widgets.goal.form',
    component: () => import('organisms/streamer/widgets/goal/GoalForm'),
    meta: {
      help: 'https://help.capusta.space/widget',
      title: 'common.fundraising',
      type: 'DONATION_GOAL',
    },
  },
  {
    path: 'notification',
    name: 'streamer.widgets.notification',
    component: () => import('organisms/streamer/widgets/NotificationWidget'),
    meta: {
      help: 'https://help.capusta.space/widget_notification',
      title: 'common.alerts',
      type: 'NOTIFICATION',
    },
  },
  {
    path: 'message',
    name: 'streamer.widgets.message',
    component: () => import('organisms/streamer/widgets/MessageWidget'),
    meta: {
      help: 'https://help.capusta.space/widget_message',
      title: 'common.messages',
      type: 'MESSAGE',
    },
  },
  {
    path: 'donors',
    name: 'streamer.widgets.donors',
    component: () => import('organisms/streamer/widgets/TopDonorsWidget'),
    meta: {
      help: 'https://help.capusta.space/widget_top',
      title: 'top.donators',
      type: 'TOP_DONORS',
    },
  },
];

const desktopRoutes = [
  {
    path: '/streamer/widgets',
    name: 'streamer.widgets',
    component: () => import('views/private/streamer/widgets/StreamerWidgets'),
    redirect: { name: 'streamer.widgets.goal' },
    meta: {
      requiresAuth: true,
      navigation: isMobileOnly,
      title: 'common.create',
    },
    children: childrenRoutes,
  },
  {
    path: '/streamer/widgets/ready',
    name: 'streamer.widgets.ready',
    component: () => import('views/private/streamer/widgets/StreamerWidgetsReady'),
    props: true,
    meta: { requiresAuth: true },
  },
];

const mobileRoutes = [
  {
    path: '/streamer/widgets',
    name: 'streamer.widgets',
    component: () => import('views/private/streamer/widgets/StreamerWidgets'),
    meta: {
      requiresAuth: true,
      navigation: isMobileOnly,
      title: 'common.create',
    },
    children: childrenRoutes,
  },
  {
    path: '/streamer/widgets/ready',
    name: 'streamer.widgets.ready',
    component: () => import('views/private/streamer/widgets/StreamerWidgetsReady'),
    props: true,
    meta: { requiresAuth: true },
  },
];

export default isMobileOnly ? mobileRoutes : desktopRoutes;
